// extracted by mini-css-extract-plugin
module.exports = {"tokenCard":"TokenCard_tokenCard__2xW3d","tokenCardContent":"TokenCard_tokenCardContent__s6zCC","randomButton":"TokenCard_randomButton__tziO6"};